import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-feetscare-satellite';

const starSvg = `<svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              data-pf-type="Icon2"
              class="sc-fFlofg gsLdLy pf-387_ pf-icon2-1"
            >
              <path
                d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                fill="currentColor"
              ></path>
            </svg>`;

const itemSatellite = (
  bgItem = '#dc9376',
  colorItem = '#ffffff',
  widthImg = 34,
  useSvg = true,
  title = 'Contours to your arch',
) => `
        <div
          data-attribute="item-satellite"
          class="item-satellite"
          data-bg-item="${bgItem}"
          data-color-item="${colorItem}"
          style="--bg-item: ${bgItem}; --color-item: ${colorItem}"
        >
          <div
            class="wrap-img-item"
            data-attribute="wrap-img-item"
            data-use-svg="${useSvg}"
            data-width-img="${widthImg}"
            style="--width-img: ${widthImg}px"
          >
            ${useSvg ? starSvg : `<img data-attribute="icon-item-image" src="" alt="" />`}
          </div>
          <div class="title-item" data-attribute="title-item">
            <p style="text-align: center">${title}</p>
          </div>
        </div>`;

const html = `
<div class="wrap-card container">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align: center">
      <span style="color: rgb(222, 165, 139)">Transform Stress into</span>
      <span style="color: rgb(0, 0, 0)">Blissful Comfort Daily</span>
    </h2>
  </div>
  <div class="body-satellite" data-attribute="body-satellite">
    <div class="wrap-item-satellite">
      <div data-attribute="items-left" class="items-left">
        ${itemSatellite()}
        ${itemSatellite()}
      </div>
      <div data-attribute="items-center" class="items-center">
        <div class="item-satellite">
          <div class="wrap-img">
            <img
              loading="lazy"
              data-attribute="satellite-image"
              class="satellite-image"
              src="https://cdn.skyfastimg.com/images/2026/08/25/image-6a8d418b99f2f7e8653d8ac3.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-attribute="items-right" class="items-right">
        ${itemSatellite()}
        ${itemSatellite()}
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#ffffff',
  textColor: '#000000',
});
